import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import styled from "styled-components";
import { selectorMapEditorStore } from "../../../../stores/MapEditorStore";
import { createActionMapViewer, disposeActionMapViewer, getActionMapViewer } from "./ActionMapViewer";
const Container = styled.div.withConfig({
  displayName: "ActionMapContainer__Container",
  componentId: "sc-t5t3sb-0"
})(["height:100%;"]);
export class ActionMapContainer extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "refElement", void 0);
  }

  componentDidMount() {
    createActionMapViewer();
    getActionMapViewer().attach(this.refElement);
    selectorMapEditorStore.increaseActionMapEditorOpenCounter();
  }

  componentWillUnmount() {
    disposeActionMapViewer();
  }

  render() {
    return /*#__PURE__*/React.createElement(Container, {
      ref: ref => {
        this.refElement = ref;
        const editorMapViewer = getActionMapViewer();
        if (!editorMapViewer) return;

        if (ref) {
          editorMapViewer.attach(ref);
        } else {
          editorMapViewer.detach();
        }
      }
    });
  }

}